import React, { useState, useEffect } from 'react';
import { Translate } from '../../../language';
import { connect } from 'react-redux'
import { createLimit, editLimit, seeGeneralLimitList } from '../../actions/certificationActions';
import inMemoryJWT from '../../../auth/inMemoryJwt';

const AuthLimitAdmin = ({ editLimit, seeGeneralLimitList, listLimit,createLimit, isLoadingLimitList, history }) => {
    const [limitUser, setLimitUser] = useState('')
    const [id, setId] = useState('')
    const [error, setError] = useState({})
    const [isValidate, setValidate] = useState(false)

   
    useEffect(() => {
        if(!(inMemoryJWT.getToken())){
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            seeGeneralLimitList()
            createLimit({
                authDeniedLimit: 2
            })
        })
        
    },[])
    
    useEffect(() => {
        setLimitUser(listLimit.authDeniedLimit)
        setId(listLimit._id)
    }, [listLimit])

    const isEmpty = (e) => {
        if (limitUser !== '') {
            setValidate(true)
        }
        const { name, placeholder, value } = e.target;
        if (value.length === 0) {
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es') + placeholder
            }));
        }
        if (value.length !== 0) {

            setError(prevError => ({
                ...prevError,
                [name]: ''
            }));
        }

    }

    const isFocused = (e) => {
        const { name } = e.target;
        setError(prevError => ({
            ...prevError,
            [name]: ''
        }));
    }

    return (
        <div className="container-admin-only-inputs">
            <div className='title-admin-list'>Editar limites para autenticación</div>
            <input className='inputs-admin input-admin-only-input'
                name="limitUser"
                type="number"
                value={limitUser}
                placeholder='Limite de rechazos para autenticación'
                onBlur={e => isEmpty(e)}
                onFocus={e => isFocused(e)}
                onKeyUp={e => isEmpty(e)}
                min="1"
                pattern="^[0-9]+"
                onChange={(e) => {
                    setLimitUser(e.target.value.trimStart())
                    if (limitUser !== '') {
                        setValidate(true)
                    }
                }}
                autoComplete="off">
            </input>
            <div className="text-error">{error.limitUser}</div>
            <button disabled={isValidate ? '' : 'disabled'}
                className={isValidate ? 'btns-admin  btn-create-edit' : 'btns-admin  btn-create-edit btn-inactive'} onClick={() => { editLimit({ authDeniedLimit: limitUser, id: id }, history) }}>Editar</button>
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        listLimit: state.certificationAdmin.listLimit,
        isLoadingLimitList: state.certificationAdmin.isLoadingLimitList
    }
}
export default connect(mapStateToProps, { seeGeneralLimitList, createLimit, editLimit })(AuthLimitAdmin) 
